var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "top20", attrs: { gutter: 30 } },
        [
          _vm.mensagem.origem === "CARTORIO"
            ? _c("el-col", { attrs: { lg: 8, md: 8, sm: 24 } }, [
                _c("span", { staticClass: "negrito" }, [_vm._v("Cartório: ")]),
                _c("span", [_vm._v(_vm._s(_vm.solicitacao.cartorio.nome))])
              ])
            : _vm._e(),
          _c("el-col", { attrs: { lg: 8, md: 8, sm: 24 } }, [
            _c("span", { staticClass: "negrito" }, [
              _vm._v("Tipo da Mensagem: ")
            ]),
            _c("span", [
              _vm._v(_vm._s(_vm.TIPO_MENSAGEM[_vm.solicitacao.tipo]))
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "top20", attrs: { gutter: 30 } },
        [
          _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
            _c("span", { staticClass: "negrito" }, [_vm._v("Despacho: ")]),
            _c("div", {
              staticClass: "top10",
              domProps: {
                innerHTML: _vm._s(
                  _vm.mensagem.despacho.replaceAll(
                    "$$BASE_URL_SISTEMA$$",
                    "#/visualizar"
                  )
                )
              }
            })
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "top20" },
        [
          _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
            _c("span", { staticClass: "negrito" }, [_vm._v("Anexos:")])
          ]),
          _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
            _vm.mensagem.anexoCartorios.length === 0
              ? _c("div", { staticClass: "top10" }, [
                  _c("span", [_vm._v("Sem anexos.")])
                ])
              : _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.mensagem.anexoCartorios }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "nome", label: "Anexo" }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Download",
                              prop: "id",
                              width: "100",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.getDownload(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "cursor fas fa-download"
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
          ]),
          _vm.ultima && _vm.aguardandoMinhaResposta(_vm.solicitacao)
            ? _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
                _c("div", { staticClass: "flex" }, [
                  _c("span", [
                    _vm._v(
                      "Responda esta mensagem até " +
                        _vm._s(_vm.solicitacao.prazo)
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.mensagem.dataVisualizacao
            ? _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
                _c("div", { staticClass: "flex" }, [
                  _c("span", [
                    _vm._v(
                      "Visualizado " + _vm._s(_vm.mensagem.dataVisualizacao)
                    )
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29bcdf78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29bcdf78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/VisualizarMensagem.vue
// module id = null
// module chunks = 